import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { PurchaseOrderLineFabricProcessing, PurchaseOrderLineFabricProcessingDetails } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderLineFabricProcessingService extends TmsWebBaseEditCreateService<
  PurchaseOrderLineFabricProcessing,
  PurchaseOrderLineFabricProcessingDetails
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseOrderLineFabricProcessing', $localize`Additional Processing`);
  }

  getFabricProcessingForPurchaseOrderLine(id: string): Observable<PurchaseOrderLineFabricProcessingDetails[]> {
    return this.httpService.get<PurchaseOrderLineFabricProcessingDetails[]>(
      `${this.apiUrl}/GetFabricProcessingForPurchaseOrderLine?id=${id}`,
    );
  }
}
